import { useMemo } from "react";

import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { LicenceOrganisationSpecialisation } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationSpecialisation";

/**
 * Generates the specialty options according to the licence organization rule provided.
 * @param userLicenceOrganizationRule The user's Licence Organization Rule
 * @returns The list of Licence Organisation Specialisations
 */
export const useSpecialtyOptionsForLicenceOrganizationRule = (userLicenceOrganizationRule: LicenceOrganisationRule): LicenceOrganisationSpecialisation[] => useMemo(
    () => {
        if (!userLicenceOrganizationRule)
            return [];

        return cacheStore.TitlesAndSpecialtiesCache
            .filter(p => p.Model.licenceOrganisationRuleModel.Id === userLicenceOrganizationRule?.Id)
            .map(p => p.Model.licenceOrganisationSpecialisationModel)
            .sortBy(p => LicenceOrganisationSpecialisation.getSpecialtyName(p))
            .toArray();
    },
    [userLicenceOrganizationRule?.Id]
);
